/**
 * Car Freshener™ — Scroll animations, FAQ accordion, sticky CTA
 */
(function () {
  /* Fade-up on scroll */
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('.cf-fade-up').forEach((el) => observer.observe(el));

  /* FAQ accordion */
  document.querySelectorAll('.cf-faq-q').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('open');
      btn.nextElementSibling.classList.toggle('open');
    });
  });

  /* Sticky mobile CTA — show after scrolling past hero */
  const hero = document.querySelector('.cf-hero');
  const sticky = document.querySelector('.cf-sticky-cta');

  if (hero && sticky) {
    const stickyObserver = new IntersectionObserver(
      ([entry]) => {
        sticky.classList.toggle('visible', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    stickyObserver.observe(hero);
  }

  /* Scroll-to-hero for final CTA links */
  document.querySelectorAll('[data-cf-scroll-to]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(el.getAttribute('data-cf-scroll-to'));
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  /* Sticky mobile CTA — AJAX add-to-cart */
  const stickyBtn = document.querySelector('[data-sticky-atc]');
  if (stickyBtn) {
    const variantInput = document.querySelector('.product-variant-id');

    if (variantInput) {
      const mo = new MutationObserver(() => {
        stickyBtn.dataset.variantId = variantInput.value;
        stickyBtn.disabled = variantInput.disabled;
        stickyBtn.textContent = variantInput.disabled ? 'ELFOGYOTT' : 'MEGRENDELEM';
      });
      mo.observe(variantInput, { attributes: true, attributeFilter: ['value', 'disabled'] });
    }

    stickyBtn.addEventListener('click', () => {
      if (stickyBtn.disabled || stickyBtn.classList.contains('loading')) return;
      const vid = variantInput ? variantInput.value : stickyBtn.dataset.variantId;
      if (!vid) return;
      stickyBtn.classList.add('loading');
      stickyBtn.innerHTML = '<span class="cf-sticky-spinner"></span>';
      window.location.href = '/cart/add?id=' + vid + '&quantity=1&return_to=/checkout';
    });
  }

  /* Social proof — live viewer count */
  const viewerEl = document.querySelector('.cf-viewer-count');
  if (viewerEl) {
    let count = parseInt(viewerEl.textContent, 10) || 9;
    setInterval(() => {
      count += Math.floor(Math.random() * 5) - 2;
      count = Math.max(4, Math.min(19, count));
      viewerEl.textContent = count;
    }, 25000 + Math.random() * 15000);
  }
})();
